/**
 * Reducer to manage note related state
 */

import { ActionTypes as types } from '../constants'
import serverProps from '../utils/serverProps'

const { note, recipientData } = serverProps

const initialState = {
  note: (note || (recipientData && recipientData.note) || '').trim(),
  isMissingMandatoryNote: false,
}

export default (state = initialState, action) => {
  switch (action.type) {
    case types.NOTE.CHANGE_NOTE:
      const {
        data: { note: newNote = '' },
      } = action
      return {
        // service has note limit of 4KB — this is roughly 4,000 english chars. Dropping to 3,500 to be cautious of emoji and special chars
        ...state,
        note: newNote.length <= 3500 ? newNote : newNote.slice(0, 3500),
      }

    case types.TRANSACTION.CANCELLED_TRANSACTION:
      return initialState

    case types.TRANSACTION.LEAVING_SUCCESS_PAGE:
      return {
        ...state,
        note: '',
      }
    case types.NOTE.REQUIRED_FIELD_ERROR:
      const {
        data: { missing: isMissingMandatoryNote },
      } = action
      return {
        ...state,
        isMissingMandatoryNote: !!isMissingMandatoryNote,
      }
    default:
      return state
  }
}
